<template>
<div>
  <div class="wistia_embed wistia_async_4ofugcu6mw">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="partnerships_cecilia"
      class="embedded_video"
      href="#wistia_smfpugmgvn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="partnerships_julia"
      class="embedded_video"
      href="#wistia_fki61toea1?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('4of', 0, this.showSelect)

    this.tbk.loadCrossTime('smf', 68, this.showSelect)
    this.tbk.loadCrossTime('fki', 71, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        smf: this.tbk.autoPlay,
        fki: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#partnerships_cecilia
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 100%
#partnerships_julia
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 100%
</style>
